import React, { createContext, useContext } from 'react';

const ManualPreviewContext = createContext(false);

export function ManualPreviewProvider({ children }) {
  return (
    <ManualPreviewContext.Provider value={true}>
      {children}
    </ManualPreviewContext.Provider>
  );
}

export function useIsManualPreview() {
  return useContext(ManualPreviewContext);
}